/** Empty state copy for admin dashboard charts/tables */
export const DASHBOARD_EMPTY_STATE = "No data for selected filters";